import React from 'react';
import { useSelector } from 'react-redux';
import { Retry } from '@components/common';
import {
  AvailableIntWrapper,
  ContentWrapper,
  PartnerCardWrapper,
  PartnerLogoWrapper,
  Tiltle,
} from './styled';
import { isAdminRoleSelector, siPagerDutyDisplayFeatureSelector } from '@store/common/selectors';
import { useFetchPartnersList } from '../list/hooks';
import Icon from '@ant-design/icons';
import { useSetAtom } from 'jotai';
import { createIntegrationAtom, partnerAtom } from '../atoms';
import { ServiceIntegrationPartner } from '../types';
import { Card, Tooltip } from 'antd';

function AvailableIntegrations({ isDrawerOpen }) {
  const {
    data: partnersData = [],
    refetch,
    isFetching,
    isError,
  } = useFetchPartnersList(isDrawerOpen);
  const displaySiPagerduty = useSelector(siPagerDutyDisplayFeatureSelector);
  const isAdminUser = useSelector(isAdminRoleSelector);
  const setPartner = useSetAtom(partnerAtom);
  const setCreateIntegration = useSetAtom(createIntegrationAtom);

  const handleAddService = (partner: ServiceIntegrationPartner) => {
    setPartner(partner);
    setCreateIntegration(true);
  };

  return (
    <ContentWrapper>
      <Retry isLoading={isFetching} showError={isError} fetchData={refetch}>
        <Tiltle>Available Channels</Tiltle>

        <AvailableIntWrapper>
          {partnersData.map((partner) =>
            // Fail-Safe: In case there is issue with AAA-849 PagerDuty migration,
            // code need not be reverted if FF is disabled
            partner.name !== 'PagerDuty' || displaySiPagerduty ? (
              <Tooltip title={`Add New ${partner.name} Integration`} key={partner.name}>
                <PartnerCardWrapper
                  key={partner.name}
                  style={
                    isAdminUser
                      ? {}
                      : {
                          pointerEvents: 'none',
                          opacity: 0.5,
                        }
                  }
                >
                  <Card
                    hoverable
                    style={{ width: 240 }}
                    bodyStyle={{ textAlign: 'center' }}
                    onClick={() => handleAddService(partner)}
                  >
                    <PartnerLogoWrapper>
                      <Icon component={partner.logo} style={{ fontSize: '100px' }} />
                    </PartnerLogoWrapper>
                  </Card>
                </PartnerCardWrapper>
              </Tooltip>
            ) : null,
          )}
        </AvailableIntWrapper>
      </Retry>
    </ContentWrapper>
  );
}

export default AvailableIntegrations;
